function addToggleButtons() {
  const toggleBtns = document.querySelectorAll(".toggle-button");
  console.log(toggleBtns);
  Array.from(toggleBtns, (btn) => btn.addEventListener("click", toggleEl));
  function toggleEl(e) {
    const button = e.target;
    const elClass = button.dataset.el;
    const el = [...document.querySelectorAll(`.${elClass}`)];

    const state = button.dataset.istoggled;
    el.forEach((el) => {
      console.log(el);
      if (state === "true") {
        delete el.dataset.toggled;
      } else {
        el.dataset.toggled = "true";
      }
    });
    Array.from(
      document.querySelectorAll(`[data-el="${elClass}"]`),
      (button) => {
        button.dataset.istoggled = state === "false" ? "true" : "false";
      }
    );
  }
}
document.addEventListener('DOMContentLoaded',addToggleButtons)

